module.exports = __webpack_public_path__ + "img/skull_7.8c95fc96.png";